import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "scale-cut",
  "use": "scale-cut-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"scale-cut\"><path d=\"M375.422 477.893H716.74v-68.264H375.422v68.264z\" /><path d=\"M546.08 887.473A443.712 443.712 0 1 0 240.74 765.691L58.202 948.16a34.132 34.132 0 1 0 48.33 48.263L292.62 810.336a33.45 33.45 0 0 0 1.365-1.366 441.664 441.664 0 0 0 252.097 78.503zm0-68.263a375.449 375.449 0 1 1 0-750.897 375.449 375.449 0 0 1 0 750.897z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol